import { ok } from "neverthrow";
import React from "react";
import {
  FormItemProvider,
  FormItemProviderProps,
} from "../../../FormItemProvider";
import identity from "../../../../../../shared/utils/identity";
import { notEmptyInputToResultWrapper } from "../../../InputToResult";
import GenericTextFormItemProvider from "../../_generic/text/GenericTextFormItemProvider";
import { eqeqeq } from "../../../../../../shared/utils/equality";

const fieldName = "Voyage Number";

const VoyageNumberFormItemProvider: FormItemProvider<string> = (props: FormItemProviderProps<string>) => (
  <GenericTextFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType="VoyageNumber"
    suggestPrevious={true}
    outputToSuggestionText={identity}
    inputToResult={notEmptyInputToResultWrapper(fieldName, ok)}
    outputToInput={identity}
    inputsEqual={eqeqeq}
  />
);

export default React.memo(VoyageNumberFormItemProvider);